import styled from 'styled-components';

interface IContainerProps {
  centerContent?: boolean;
}

export const Container = styled.div<IContainerProps>`
  min-height: 100vh;
  padding: 0;
  display: flex;
  align-items: ${({ centerContent }) => (centerContent ? 'center' : 'start')};
  justify-content: center;

  @media only screen and (min-width: 500px) {
    padding-top: ${({ centerContent }) => (centerContent ? '0' : '20px')};
  }
`;

export const FrameContainer = styled.div`
  /* border-top-color: #ffa200;
  border-top-style: solid;
  border-top-width: 10px; */
  padding: 30px;
  display: flex;
  gap: 14px;
  flex-direction: column;
  background-color: white;
  border-radius: 28px;
  width: 90%;
  /* max-height: 90vh; */

  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 6px; /*largura da barra de rolagem*/
  }
  ::-webkit-scrollbar-thumb {
    /*barra de rolagem*/
    background-color: gray;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-track {
    /*barra total*/
    background-color: transparent;
  }

  @media only screen and (max-width: 500px) {
    padding: 40px 24px;
    height: 100%;
    width: 100%;
    border-radius: unset;
    max-height: unset;
  }
`;
